<template>
  <v-theme-provider dark>
    <base-section
      id="info"
      class="grey darken-4"
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <base-business-info />
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionBusinessInfo',
  }
</script>

<style lang="scss">
  #info-alt {
    a {
      text-decoration: none
    }
  }
</style>
